export default function (callback: () => any) {
  const { overlays } = useOverlay()

  const componentName = getCurrentInstance()?.type.__name

  defineShortcuts({
    meta_s: {
      handler: () => {
        const openOverlays = overlays.filter(overlay => overlay.isOpen)
        if (openOverlays.length <= 1)
          return callback()
        const overlayComponentName = (openOverlays[openOverlays.length - 1].component as undefined | Component & { __name?: string })?.__name
        if (overlayComponentName !== undefined && overlayComponentName !== componentName) // TODO: find cleaner yet equally simple way to check if modal is latest modal
          return
        callback()
      },
      usingInput: true,
    },
  })
}
